export const testimonials = [
  {
    id: 1,
    name: "Marcus Rivera",
    role: "Owner & Operator",
    avatar: "https://readdy.ai/api/search-image?query=professional%20headshot%20of%20a%20confident%20hispanic%20man%20in%20his%20late%2030s%20wearing%20a%20blue%20collar%20work%20shirt%2C%20natural%20studio%20lighting%2C%20warm%20tones%2C%20slightly%20smiling%2C%20clean%20simple%20background&width=80&height=80&seq=avatar-testimonial-01&orientation=squarish",
    content: "I was spending $400 a month on a copywriter just for Facebook ads. AdForge replaced that in one afternoon. The copy it generates actually sounds like me — not some robot. My click-through rate went up 47% in the first month.",
    stars: 5,
    business: "Construction",
  },
  {
    id: 2,
    name: "Priya Nair",
    role: "Content Manager",
    avatar: "https://readdy.ai/api/search-image?query=professional%20headshot%20of%20an%20elegant%20indian%20woman%20in%20her%20early%2030s%20with%20dark%20hair%2C%20business%20casual%20attire%2C%20warm%20natural%20lighting%2C%20confident%20smile%2C%20neutral%20background&width=80&height=80&seq=avatar-testimonial-02&orientation=squarish",
    content: "I manage 12 client accounts and AdForge saves me probably 6 hours every week. The agency plan is a steal. I generate 50+ ad variations per week and clients think I have a full creative team.",
    stars: 5,
    business: "Social Media Agency",
  },
  {
    id: 3,
    name: "Derek Olson",
    role: "Owner",
    avatar: "https://readdy.ai/api/search-image?query=professional%20headshot%20of%20a%20fit%20athletic%20white%20man%20in%20his%2040s%20with%20short%20hair%2C%20wearing%20a%20smart%20casual%20polo%20shirt%2C%20clean%20white%20studio%20background%2C%20confident%20natural%20expression&width=80&height=80&seq=avatar-testimonial-03&orientation=squarish",
    content: "We launched a new product line and needed 30 Google Ads variants fast. AdForge did it in under 10 minutes. Our ROAS jumped from 2.1x to 3.8x using the hooks it generated. Genuinely shocked how good the output is.",
    stars: 5,
    business: "E-commerce / Supplements",
  },
  {
    id: 4,
    name: "Camille Fontaine",
    role: "Social Media Influencer",
    avatar: "https://readdy.ai/api/search-image?query=professional%20headshot%20of%20a%20stylish%20french%20woman%20in%20her%20late%2020s%20with%20elegant%20features%20and%20chic%20attire%2C%20soft%20warm%20studio%20lighting%2C%20friendly%20confident%20smile%2C%20neutral%20clean%20background&width=80&height=80&seq=avatar-testimonial-04&orientation=squarish",
    content: "Before AdForge I would stare at a blank screen for an hour trying to write Instagram captions. Now I generate 10 options in 30 seconds and pick the best one. My engagement has never been higher.",
    stars: 5,
    business: "Interior Decorator",
  },
];